import React, { useRef, useState, useContext, useEffect } from "react";
import CanvasSection from "./CanvasSection";
import LeftSidebar from "./LeftsieBar";
import Layers from "./Layers";
import RightSidebar from "./RightSidebar";
import "./Editor.css";
import CodeGenerator from "./CodeGenerator";
import Navbar from "./Navbar";
import PageManager from "./PageManager";
import FileManager from "./FileManager";
import LandingNavbarAtEditor from "../../LandingComponents/LandingNavbarAtEditor";
import DownloadProgress from "./DownloadProgress"
import { CanvasContext } from "../../../contexts/CanvasContext";
import Documentation from "../../LandingComponents/LandingDocumentation";

const Editor = () => {
  const [showCode, setShowCode] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [showDocumentation, setShowDocumentation] = useState(false);
  const [showLandingNavbar, setShowLandingNavbar] = useState(false);
  const [triggerDownload, setTriggerDownload] = useState(false);

  const landingNavbarRef = useRef(null);
  const pagemanager = useRef(null);
  const fileManagerRef = useRef(null);

  const {
    currentPage,
    setCurrentPage,
    showLeftSidebar,
    setShowLeftSidebar,
    showRightSidebar,
    setShowRightSidebar,
    showLayers,
    setShowLayers,
    showProperties,
    setShowProperties,
    showPageManager,
    setShowPageManager,
    LayOut,
    setLayOut,
    setShowFileManager,
    isDownloading,
  } = useContext(CanvasContext);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        landingNavbarRef.current &&
        !landingNavbarRef.current.contains(event.target) &&
        !event.target.closest(".button")
      ) {
        setShowLandingNavbar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutsidePage = (event) => {
      if (
        pagemanager.current &&
        !pagemanager.current.contains(event.target) &&
        !event.target.closest(".button")
      ) {
        setShowPageManager(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsidePage);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsidePage);
    };
  }, [setShowPageManager]);

  useEffect(() => {
    const handleClickOutsideFilemanager = (event) => {
      if (
        fileManagerRef.current &&
        !fileManagerRef.current.contains(event.target) &&
        !event.target.closest(".button")
      ) {
        setShowFileManager(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideFilemanager);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideFilemanager);
    };
  }, [setShowFileManager]);

  return (
    <>
      {(() => {
        switch (LayOut) {
          case 0:
            return (
              <div style={{ display: "flex",backgroundColor:"#ffffff" }}>
                <Navbar
                  showCode={showCode}
                  setShowCode={setShowCode}
                  setTriggerDownload={setTriggerDownload}
                  showLeftSidebar={showLeftSidebar}
                  setShowLeftSidebar={setShowLeftSidebar}
                  showRightSidebar={showRightSidebar}
                  setShowRightSidebar={setShowRightSidebar}
                  showPageManager={showPageManager}
                  setShowPageManager={setShowPageManager}
                  showPreview={showPreview}
                  setShowPreview={setShowPreview}
                  showLayers={showLayers}
                  setShowLayers={setShowLayers}
                  showProperties={showProperties}
                  setShowProperties={setShowProperties}
                  setShowLandingNavbar={setShowLandingNavbar}
                  showLandingNavbar={showLandingNavbar}
                  setShowDocumentation={setShowDocumentation}
                  LayOut={LayOut}
                  setLayOut={setLayOut}
                />
                {showLandingNavbar && (
                  <div ref={landingNavbarRef}>
                    <LandingNavbarAtEditor
                      showDocumentation={showDocumentation}
                      setShowDocumentation={setShowDocumentation}
                      setShowCode={setShowCode}
                      setShowPreview={setShowPreview}
                      LayOut={LayOut}
                    />
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  {showDocumentation && !showCode && !showPreview && (
                    <Documentation />
                  )}
                  <CodeGenerator
                    showCode={showCode ? showCode : undefined}
                    showPreview={showPreview}
                    triggerDownload={triggerDownload}
                    setTriggerDownload={setTriggerDownload}
                  />
                  {!showDocumentation && showPageManager && (
                    <div className="pagemanagerInEditorZero">
                      <PageManager
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        LayOut={LayOut}
                      />
                    </div>
                  )}
                  {!showDocumentation &&
                    !showCode &&
                    !showPreview &&
                    showLeftSidebar && (
                      <div className="LeftSideBarInEditorZero">
                        <LeftSidebar />
                      </div>
                    )}
                  {!showDocumentation && !showCode && !showPreview && (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        padding: ".5rem",
                      }}
                    >
                      <CanvasSection LayOut={LayOut} />
                    </div>
                  )}
                  {!showDocumentation && !showCode && !showPreview && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100vh",
                        position: "sticky",
                        top: "0",
                        right: "0",
                        zIndex: "1000",
                        maxWidth: "15vw",
                      }}
                    >
                      {showLayers && <Layers LayOut={LayOut} />}
                      {showProperties && <RightSidebar />}
                    </div>
                  )}
                  <div ref={fileManagerRef}>
                    {!showDocumentation && !showCode && (
                      <FileManager showPreview={showPreview} />
                    )}
                  </div>
                </div>
              </div>
            );

          case 1:
            return (
              <div style={{backgroundColor:"#ffffff"}}>
                <div>
                  <Navbar
                    showCode={showCode}
                    setShowCode={setShowCode}
                    setTriggerDownload={setTriggerDownload}
                    showLeftSidebar={showLeftSidebar}
                    setShowLeftSidebar={setShowLeftSidebar}
                    showRightSidebar={showRightSidebar}
                    setShowRightSidebar={setShowRightSidebar}
                    showPageManager={showPageManager}
                    setShowPageManager={setShowPageManager}
                    showPreview={showPreview}
                    setShowPreview={setShowPreview}
                    showLayers={showLayers}
                    setShowLayers={setShowLayers}
                    showProperties={showProperties}
                    setShowProperties={setShowProperties}
                    setShowLandingNavbar={setShowLandingNavbar}
                    showLandingNavbar={showLandingNavbar}
                    setShowDocumentation={setShowDocumentation}
                    LayOut={LayOut}
                    setLayOut={setLayOut}
                  />
                  {showLandingNavbar && (
                    <div ref={landingNavbarRef}>
                      <LandingNavbarAtEditor
                        showDocumentation={showDocumentation}
                        setShowDocumentation={setShowDocumentation}
                        setShowCode={setShowCode}
                        setShowPreview={setShowPreview}
                        LayOut={LayOut}
                      />
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100vw",
                    position: "relative",
                    top: "5vh",
                  }}
                >
                  {showDocumentation && !showCode && !showPreview && (
                    <Documentation />
                  )}
                  <CodeGenerator
                    showCode={showCode ? showCode : undefined}
                    showPreview={showPreview}
                    triggerDownload={triggerDownload}
                    setTriggerDownload={setTriggerDownload}
                  />
                  {!showDocumentation &&
                    !showCode &&
                    !showPreview &&
                    showLeftSidebar && (
                      <div className="LeftSideBarInEditorOne">
                        <LeftSidebar />
                      </div>
                    )}
                  {!showDocumentation && !showCode && !showPreview && (
                    <div
                      style={{
                        width: "100%",
                        height: "95vh",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          minHeight: "70%",
                          position: "relative",
                          overflow: "hidden",
                          paddingLeft: ".5rem",
                          paddingTop: ".3rem",
                        }}
                      >
                        <CanvasSection LayOut={LayOut} />
                      </div>
                      {(showLayers || showProperties) && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "87vw",
                            minHeight: "30%",
                            zIndex: "1000",
                            // padding:".2rem"
                          }}
                        >
                          {showLayers && <Layers LayOut={LayOut} />}
                          {showProperties && <RightSidebar />}
                        </div>
                      )}
                    </div>
                  )}
                  {!showDocumentation && showPageManager && (
                    <div className="pagemanagerInEditorOne" ref={pagemanager}>
                      <PageManager
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        LayOut={LayOut}
                      />
                    </div>
                  )}
                  <div ref={fileManagerRef}>
                    {!showDocumentation && !showCode && <FileManager />}
                  </div>
                </div>
              </div>
            );

          case 2:
            return (
              <div style={{backgroundColor:"#ffffff"}}>
                <div>
                  <Navbar
                    showCode={showCode}
                    setShowCode={setShowCode}
                    setTriggerDownload={setTriggerDownload}
                    showLeftSidebar={showLeftSidebar}
                    setShowLeftSidebar={setShowLeftSidebar}
                    showRightSidebar={showRightSidebar}
                    setShowRightSidebar={setShowRightSidebar}
                    showPageManager={showPageManager}
                    setShowPageManager={setShowPageManager}
                    showPreview={showPreview}
                    setShowPreview={setShowPreview}
                    showLayers={showLayers}
                    setShowLayers={setShowLayers}
                    showProperties={showProperties}
                    setShowProperties={setShowProperties}
                    setShowLandingNavbar={setShowLandingNavbar}
                    showLandingNavbar={showLandingNavbar}
                    setShowDocumentation={setShowDocumentation}
                    LayOut={LayOut}
                    setLayOut={setLayOut}
                  />
                  {showLandingNavbar && (
                    <div ref={landingNavbarRef}>
                      <LandingNavbarAtEditor
                        showDocumentation={showDocumentation}
                        setShowDocumentation={setShowDocumentation}
                        setShowCode={setShowCode}
                        setShowPreview={setShowPreview}
                        LayOut={LayOut}
                      />
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    position: "relative",
                    top: "5vh",
                  }}
                >
                  {showDocumentation && !showCode && !showPreview && (
                    <Documentation />
                  )}
                  <CodeGenerator
                    showCode={showCode ? showCode : undefined}
                    showPreview={showPreview}
                    triggerDownload={triggerDownload}
                    setTriggerDownload={setTriggerDownload}
                  />
                  <div
                    style={{
                      height: "95vh",
                      maxWidth: "15vw",
                      display: "flex",
                      flexDirection: "column",
                      position: "sticky",
                      top: "0",
                      left: "0",
                    }}
                  >
                    {!showDocumentation &&
                      !showCode &&
                      !showPreview &&
                      showLeftSidebar && <LeftSidebar />}
                    {!showDocumentation && showPageManager && (
                      <PageManager
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        LayOut={LayOut}
                      />
                    )}
                  </div>
                  {!showDocumentation && !showCode && !showPreview && (
                    <div
                      style={{
                        width: "100%",
                        height: "95vh",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          minHeight: "70%",
                          position: "relative",
                          overflow: "hidden",
                          padding: ".5rem",
                        }}
                      >
                        <CanvasSection LayOut={LayOut} />
                      </div>
                      {(showLayers || showProperties) && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "87vw",
                            height: "30%",
                            zIndex: "1000",
                          }}
                        >
                          {showLayers && <Layers LayOut={LayOut} />}
                          {showProperties && <RightSidebar />}
                        </div>
                      )}
                    </div>
                  )}
                  <div ref={fileManagerRef}>
                    {!showDocumentation && !showCode && <FileManager />}
                  </div>
                </div>
              </div>
            );

          case 3:
            return (
              <>
                <div style={{backgroundColor:"#ffffff"}}>
                  <Navbar
                    showCode={showCode}
                    setShowCode={setShowCode}
                    setTriggerDownload={setTriggerDownload}
                    showLeftSidebar={showLeftSidebar}
                    setShowLeftSidebar={setShowLeftSidebar}
                    showRightSidebar={showRightSidebar}
                    setShowRightSidebar={setShowRightSidebar}
                    showPageManager={showPageManager}
                    setShowPageManager={setShowPageManager}
                    showPreview={showPreview}
                    setShowPreview={setShowPreview}
                    showLayers={showLayers}
                    setShowLayers={setShowLayers}
                    showProperties={showProperties}
                    setShowProperties={setShowProperties}
                    setShowLandingNavbar={setShowLandingNavbar}
                    showLandingNavbar={showLandingNavbar}
                    setShowDocumentation={setShowDocumentation}
                    LayOut={LayOut}
                    setLayOut={setLayOut}
                  />
                  {showLandingNavbar && (
                    <div ref={landingNavbarRef}>
                      <LandingNavbarAtEditor
                        showDocumentation={showDocumentation}
                        setShowDocumentation={setShowDocumentation}
                        setShowCode={setShowCode}
                        setShowPreview={setShowPreview}
                        LayOut={LayOut}
                      />
                    </div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100vw",
                    position: "relative",
                    top: "6vh",
                    height: "94vh",
                    overflow: "hidden",
                  }}
                >
                  {showDocumentation && !showCode && !showPreview && (
                    <Documentation />
                  )}
                  <CodeGenerator
                    showCode={showCode ? showCode : undefined}
                    showPreview={showPreview}
                    triggerDownload={triggerDownload}
                    setTriggerDownload={setTriggerDownload}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      height: "94vh",
                      // minWidth: "15vw",
                      maxWidth: "100%",
                    }}
                  >
                    {!showDocumentation && !showCode && !showPreview && (
                      <div
                        style={{
                          height: "100%",
                          position: "relative",
                          overflow: "hidden",
                          paddingLeft: ".6rem",
                          paddingBlock: "0",
                          width: "100%",
                          padding: "1rem",
                        }}
                      >
                        <CanvasSection LayOut={LayOut} />
                      </div>
                    )}
                    <div ref={fileManagerRef}>
                      {!showDocumentation && !showCode && <FileManager />}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        height: "30%",
                        position: "relative",
                        bottom: "0",
                        left: "0",
                      }}
                    >
                      {!showDocumentation &&
                        !showCode &&
                        !showPreview &&
                        showLeftSidebar && (
                          <div className="LeftSideBarInEditorThree">
                            <LeftSidebar />
                          </div>
                        )}
                      {!showDocumentation &&
                        !showCode &&
                        !showPreview &&
                        showLayers && (
                          <div style={{ width: "100%" }}>
                            <Layers LayOut={LayOut} />
                          </div>
                        )}
                      {!showDocumentation &&
                        !showCode &&
                        !showPreview &&
                        showProperties && (
                          <div style={{ width: "100%" }}>
                            <RightSidebar />
                          </div>
                        )}

                      {!showDocumentation && showPageManager && (
                        <div className="pagemanagerInEditorThree">
                          <PageManager
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            LayOut={LayOut}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            );

          default:
            return (
              <div style={{ display: "flex",backgroundColor:"#ffffff" }}>
                <Navbar
                  showCode={showCode}
                  setShowCode={setShowCode}
                  setTriggerDownload={setTriggerDownload}
                  showLeftSidebar={showLeftSidebar}
                  setShowLeftSidebar={setShowLeftSidebar}
                  showRightSidebar={showRightSidebar}
                  setShowRightSidebar={setShowRightSidebar}
                  showPageManager={showPageManager}
                  setShowPageManager={setShowPageManager}
                  showPreview={showPreview}
                  setShowPreview={setShowPreview}
                  showLayers={showLayers}
                  setShowLayers={setShowLayers}
                  showProperties={showProperties}
                  setShowProperties={setShowProperties}
                  setShowLandingNavbar={setShowLandingNavbar}
                  showLandingNavbar={showLandingNavbar}
                  setShowDocumentation={setShowDocumentation}
                  LayOut={LayOut}
                  setLayOut={setLayOut}
                />
                {showLandingNavbar && (
                  <div ref={landingNavbarRef}>
                    <LandingNavbarAtEditor
                      showDocumentation={showDocumentation}
                      setShowDocumentation={setShowDocumentation}
                      setShowCode={setShowCode}
                      setShowPreview={setShowPreview}
                      LayOut={LayOut}
                    />
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  {showDocumentation && !showCode && !showPreview && (
                    <Documentation />
                  )}
                  <CodeGenerator
                    showCode={showCode ? showCode : undefined}
                    showPreview={showPreview}
                    triggerDownload={triggerDownload}
                    setTriggerDownload={setTriggerDownload}
                  />
                  {!showDocumentation && showPageManager && (
                    <div className="pagemanagerInEditorZero">
                      <PageManager
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        LayOut={LayOut}
                      />
                    </div>
                  )}
                  {!showDocumentation &&
                    !showCode &&
                    !showPreview &&
                    showLeftSidebar && (
                      <div className="LeftSideBarInEditorZero">
                        <LeftSidebar />
                      </div>
                    )}
                  {!showDocumentation && !showCode && !showPreview && (
                    <div
                      style={{ width: "100%", height: "100%", padding: "1rem" }}
                    >
                      <CanvasSection />
                    </div>
                  )}
                  {!showDocumentation && !showCode && !showPreview && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100vh",
                        position: "sticky",
                        top: "0",
                        right: "0",
                        zIndex: "1000",
                        maxWidth: "15vw",
                      }}
                    >
                      {showLayers && <Layers LayOut={LayOut} />}
                      {showProperties && <RightSidebar />}
                    </div>
                  )}
                  <div ref={fileManagerRef}>
                    {!showDocumentation && !showCode && <FileManager />}
                  </div>
                </div>
              </div>
            );
        }
      })()}
      <DownloadProgress />
      {isDownloading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50"></div>
      )}
    </>
  );
};

export default Editor;
